import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import { configureHttpAuth } from '@/platform/http/authBridge'
import {
  clearSessionTokens,
  getAccessToken,
  getValidAccessToken,
  refreshAccessToken,
  redirectToLogin,
} from '@/platform/session/sessionTokens'
import { configureReducerInjector } from '@/platform/state/reducerRegistry'
import { injectReducer } from '@/app/store/store'

export function bootstrap(): void {
  configureReducerInjector(injectReducer)
  configureHttpAuth({
    getAccessToken,
    getValidAccessToken,
    refreshAccessToken,
    onSessionExpired: () => {
      clearSessionTokens()
      redirectToLogin()
    },
  })
  createRoot(document.getElementById('root')!).render(<App />)
}
